// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card-title[data-v-0e2990bb] {\n    margin: 10px;\n}\n.justify-content-space-evenly[data-v-0e2990bb] {\n    justify-content: space-evenly;\n}\n.align-items-center[data-v-0e2990bb] {\n    align-items: center;\n}\n.justify-content-end[data-v-0e2990bb] {\n    justify-content: end;\n}\n", ""]);
// Exports
module.exports = exports;
